/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle01Icon64Regular = forwardRef('NumberCircle01Icon64Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 64 }, props),
        React.createElement("path", { d: "M34.587 41.654V19.962h-2.278l-7.412 5.644 1.496 2.074 5.168-3.876v17.85h-5.95V44h14.586v-2.346h-5.61Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M32 6C17.64 6 6 17.64 6 32s11.64 26 26 26 26-11.64 26-26S46.36 6 32 6ZM9 32C9 19.297 19.297 9 32 9s23 10.297 23 23-10.297 23-23 23S9 44.703 9 32Z" })));
});
